import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { AdminService } from "src/app/shared/services/admin/admin.service";
import {
  courseTeachersListLoad,
  courseTeachersListLoadFail,
  courseTeachersListLoadSuccess,
} from "../../actions/admin/course-teachers.actions";
import { Store } from "@ngrx/store";
import { AdminCourseList } from "../../reducers/admin/course-admin.reducer";
import { SubscriptionOrganization } from "src/app/shared/interfaces/orgadmin/course-organization";

@Injectable()
export class CourseTeachersEffect {
  getInvitedTeachersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(courseTeachersListLoad),
      switchMap(({ organizationId, subId, search }) =>
        this.adminService
          .getSingleSubscription(organizationId, subId, search)
          .pipe(
            map((res: SubscriptionOrganization) =>
              courseTeachersListLoadSuccess({ teachersList: res }),
            ),
            catchError(({ error }) => of(courseTeachersListLoadFail(error))),
          ),
      ),
    ),
  );

  constructor(
    private adminService: AdminService,
    private actions$: Actions,
    private store: Store<{ course: AdminCourseList }>,
  ) {}
}
